import React from 'react';
import PropTypes from 'prop-types';

import Filter from 'ui/Filter';
import SearchableFilter from 'ui/SearchableFilter';

const MerchFilter = ({ onChange }) => {

  const itemFilter = <SearchableFilter key="merch_item" onChange={onChange} label="merch_item" customLabel="Filter by item" />;

  const statusFilter = <Filter key="status" onChange={onChange} label="status" table={'merch'} />;

  return (
    [itemFilter, statusFilter]
  );
};

MerchFilter.propTypes = {
  onChange: PropTypes.func,
};

export default MerchFilter;
